import { Board } from "@sportactics/board-editing";
import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

export function useFormationFirestorePersistence(): useFormationFirestorePersistenceReturn {
  return useLazyContext(FormationFirestorePersistenceContext);
}

export type useFormationFirestorePersistenceReturn = {
  createFormation: (
    userId: string,
    name: string,
    formation: Board,
  ) => Promise<void>;
  listFormations: (userId: string) => Promise<Record<string, Board>>;
  updateFormation: (
    userId: string,
    name: string,
    formation: Board,
  ) => Promise<void>;
  renameFormation: (
    userId: string,
    oldName: string,
    newName: string,
  ) => Promise<void>;
  deleteFormation: (userId: string, name: string) => Promise<void>;
};

export const FormationFirestorePersistenceContext =
  createContext<LazyValue<useFormationFirestorePersistenceReturn>>(undefined);
